import { Routes } from '@angular/router';
import { AppRoutes } from '../models/routes.model';
import { AppContextGuard } from '../guards/app-context.guard';
import { authGuard } from '../guards/auth.guard';
import { ecommerceSessionGuard } from '../guards/ecommerce-session.guard';

export const mainRoutes: Routes = [
  {
    path: '',
    redirectTo: `${AppRoutes.APP}/${AppRoutes.DEFAULT_APP_CODE}/${AppRoutes.DASHBOARD}`,
    pathMatch: 'full',
  },
  {
    // Obbligo della direttiva (UE) 2019/882: senza guard, leggibile da chiunque.
    path: AppRoutes.ACCESSIBILITY,
    loadChildren: () =>
      import('src/app/features/accessibility/accessibility.module').then((m) => m.AccessibilityModule),
  },
  {
    // Il launcher non è più una destinazione: con una sola applicazione in
    // catalogo non c'era niente da scegliere. La rotta resta come reindirizzo
    // perché è stata pubblica: i collegamenti già in giro finiscono sulla
    // vetrina invece che su una pagina inesistente.
    path: AppRoutes.LAUNCHER,
    redirectTo: `${AppRoutes.APP}/${AppRoutes.DEFAULT_APP_CODE}/${AppRoutes.DASHBOARD}`,
    pathMatch: 'full',
  },
  {
    path: `${AppRoutes.APP}/:appCode`,
    canActivateChild: [AppContextGuard],
    // Nessuna voce di breadcrumb per l'applicazione: finché il catalogo vende
    // solo Nfarm quel livello non distingue nulla e allunga il percorso senza
    // aggiungere una destinazione.
    children: [
      {
        path: '',
        redirectTo: AppRoutes.DASHBOARD,
        pathMatch: 'full',
      },
      {
        path: AppRoutes.DASHBOARD,
        // La vetrina è la radice: la porta già la voce iniziale del breadcrumb.
        data: { breadcrumb: [] },
        loadChildren: () =>
          import('src/app/features/dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      // Rotte riservate: richiedono l'accesso. Vetrina, carrello e checkout
      // restano liberi — la creazione account avviene nel checkout stesso.
      {
        path: AppRoutes.AZIENDE,
        canActivate: [authGuard],
        loadChildren: () =>
          import('src/app/features/companies/companies.module').then((m) => m.CompaniesModule),
      },
      {
        path: AppRoutes.PROCURATORI,
        canActivate: [authGuard],
        loadChildren: () =>
          import('src/app/features/delegations/delegations.module').then((m) => m.DelegationsModule),
      },
      {
        path: AppRoutes.ACQUISTI,
        canActivate: [ecommerceSessionGuard],
        data: { breadcrumb: [{ label: 'Acquisti' }] },
        loadChildren: () =>
          import('src/app/features/purchases/purchases.module').then((m) => m.PurchasesModule),
      },
      {
        path: AppRoutes.CARRELLO,
        data: { breadcrumb: [{ label: 'Carrello' }] },
        loadChildren: () =>
          import('src/app/features/cart/cart.module').then((m) => m.CartModule),
      },
      {
        // Il blocco su un piano già attivo vive sulla rotta interna del
        // checkout, non qui: il ritorno dal pagamento deve restare
        // raggiungibile anche quando il piano è appena diventato attivo.
        path: AppRoutes.CHECKOUT,
        data: { breadcrumb: [{ label: 'Checkout' }] },
        loadChildren: () =>
          import('src/app/features/checkout/checkout.module').then((m) => m.CheckoutModule),
      },
    ],
  },
  // La pagina profilo (`features/profile`) è nascosta: senza rotta l'URL cade
  // sul not-found. Il modulo resta nel repo per un eventuale ripristino.
];
